import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import OrganizationContainer from './state/OrganizationContainer';

export function useCurrentOrgNavigation() {
    const navigate = useNavigate();
    const { organizationId } = useParams();
    const organizationContainer = OrganizationContainer.useContainer();

    useEffect(() => {
        const handlePermissionChangeRedirect = () => {
            if (
                !organizationContainer?.membershipsRef?.current ||
                organizationContainer.membershipsRef.current?.length < 1
            ) {
                navigate('/', { replace: true });
                return;
            }
            const currentMember = organizationContainer.getOrganizationMembership(organizationId);
            if (!currentMember) {
                navigate('/', { replace: true });
            }
        };

        const handleOrgNullRedirect = () => {
            if (!organizationId) {
                navigate('/', { replace: true });
            }
        };

        handlePermissionChangeRedirect();
        handleOrgNullRedirect();
    }, [organizationId, organizationContainer.memberships]);
}
